export default __webpack_public_path__ + "static/media/9.c12e6ca7.jpg";